//@ts-check
import React, { Component } from 'react';
import { Button, Modal, message } from 'antd';
import { FormContainer, FormInput } from 'module/form';
import './add-license.scss';
import './authenticate-license2.scss';

import { FormattedMessage } from 'react-intl';
import { getfetchopts } from 'utils/fetchutils';
import { logout } from 'utils/store';
import axios from 'axios';
class AddLicense extends Component {
    state = {
        errorMessageModalVisible: false,
        errorMessage: '',
    };

    submit = async (values) => {
        const licenseKey = values.licenseKey?.trim();

        if (!licenseKey) {
            message.error('Please enter a license key');
            return;
        }

        await this.submitLicense(licenseKey);
    };

    submitLicense = async (licenseKey) => {
        console.log('Submitting license key:', licenseKey ? 'Key provided' : 'Key is empty!');
        try {
            const config = getfetchopts({
                method: 'POST',
                url: `/api/identity/license`,
                data: {
                    license_key: licenseKey
                }
            });
            const result = await axios.request(config);
            console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, result);
            message.success('License installed successfully!');

            // Close modal and reload data
            this.props.reload();
            this.props.closeLicenseAddModel();
        } catch (e) {
            console.error('Error creating license:', e);
            if (e.response && e.response.status === 401) {
                logout();
            } else if (e.response && e.response.status === 400) {
                // Handle validation errors (like expired license)
                const errorData = e.response.data;
                let errorMessage = errorData.message || 'License validation failed';

                if (errorData.license_details && errorData.license_details.days_expired) {
                    errorMessage += `\n\nThis license expired ${errorData.license_details.days_expired} day(s) ago.`;
                }

                message.error(errorMessage);
            } else if (e.response && e.response.status === 409) {
                // Handle conflict error with detailed message
                const errorData = e.response.data;
                let errorMessage = errorData.message || 'License conflict detected';

                if (errorData.conflict_details && errorData.conflict_details.conflicting_licenses) {
                    const conflicts = errorData.conflict_details.conflicting_licenses;
                    errorMessage += `\n\nExisting conflicting license(s):`;
                    conflicts.forEach(conflict => {
                        errorMessage += `\n• ${conflict.license_type} (${conflict.date_range})`;
                    });
                }

                message.error(errorMessage);
            } else {
                message.error(e.response?.data?.message || e.message || 'Failed to install license');
            }
        }
    };

    setErrorMessageModalVisible = (errorMessageModalVisible) => {
        this.setState({ errorMessageModalVisible });
    };

    getForm = () => {
        return (
            <div className="authentication-license2">
                <p>
                    <FormattedMessage
                        id="licenses.label.add_license.text1"
                        defaultMessage="Please enter the License Key that you received via email and click SUBMIT to install it."
                    />
                </p>

                <FormContainer
                    layout="horizontal"
                    className="license-key-form"
                    onSubmit={this.submit}
                >
                    <FormInput
                        name="licenseKey"
                        type="textarea"
                        rows={4}
                        label={
                            <FormattedMessage
                                id="licenses.label.add_license.label.key"
                                defaultMessage="License Key"
                            />
                        }
                        placeholder="Enter your license key here..."
                        colon={false}
                        maxLength={1000}
                        required
                    />

                    <Button htmlType="submit" type="primary" id='btn_submit_license'>
                        <FormattedMessage
                            id="licenses.label.add_license.button.submit"
                            defaultMessage="SUBMIT"
                        />
                    </Button>
                </FormContainer>

                <br />
            </div>
        );
    };

    render() {
        const { errorMessage, errorMessageModalVisible } = this.state;
        return (
            <>
                <Modal
                    title={
                        <FormattedMessage
                            id="licenses.label.add_license.modal.title"
                            defaultMessage="Add License"
                        />
                    }
                    width={900}
                    visible={this.props.licenseAddVisible}
                    destroyOnClose={true}
                    className="admin-create-license"
                    footer={null}
                    onCancel={this.props.closeLicenseAddModel}
                    maskClosable={false}
                >
                    {this.getForm()}
                </Modal>
                <Modal
                    visible={errorMessageModalVisible}
                    title={null}
                    footer={null}
                    width={600}
                    onCancel={() => this.setErrorMessageModalVisible(false)}
                >
                    <div className="txt-dark">
                        An issue has occurred during the loading of your License
                        Key. Please contact Spectralink Customer Support and
                        report the error code below.
                    </div>
                    <br />
                    <table className="border-table txt-dark">
                        <tbody>
                            <tr className="table-group">
                                <td colSpan={4}> North America</td>
                            </tr>
                            <tr>
                                <td>United States and Canada</td>
                                <td>Tel: 1-800-775-5330</td>
                                <td></td>
                                <td>English</td>
                            </tr>
                            <tr>
                                <td>Mexico Tech Support</td>
                                <td>Tel: +001-800-775-5330</td>
                                <td></td>
                                <td>English</td>
                            </tr>
                            <tr className="table-group">
                                <td colSpan={4}>
                                    Europe, Middle East, and Atrica (EMEA)
                                </td>
                            </tr>
                            <tr>
                                <td>France Tech Support</td>
                                <td>Tel: +33 176774541</td>
                                <td></td>
                                <td>Danish + English</td>
                            </tr>
                            <tr>
                                <td>Germany</td>
                                <td>Tel: 0800588900</td>
                                <td></td>
                                <td>Danish + English</td>
                            </tr>
                            <tr>
                                <td>Rest of EMEA </td>
                                <td>Tel: +45 76 281 281</td>
                                <td></td>
                                <td>Danish + English</td>
                            </tr>
                            <tr className="table-group">
                                <td colSpan={4}>Asia Pacific</td>
                            </tr>
                            <tr>
                                <td>Technical Support </td>
                                <td>Tel: +61-2-90370834</td>
                                <td></td>
                                <td>English</td>
                            </tr>
                        </tbody>
                    </table>
                    <br />
                    <div className="text-center">
                        <span className="txt-orange">ERROR CODE</span>:{' '}
                        <span className="txt-dark bold">
                            {/*XX-XXXX-X*/} {errorMessage}
                        </span>
                    </div>
                </Modal>
            </>
        );
    }
}

export default AddLicense;
